import * as actionTypes from 'constants/actionTypes';

import { initialState } from 'selectors/contactTypes';

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.CONTACT_TYPES_FETCH_SUCCESS:
      return [...payload.collection];
    case actionTypes.CONTACT_TYPES_RESET:
      return initialState;
    default:
      return state;
  }
};
